<div class="container">
  <hr>
  <h2><a id="how-to" href="/#jesteer">How to Use Jesteer</a></h2>
  <div class="howTo-container">
    <div class="howTo">
      <div class="howTo-text">
        <h3>Record a path through your app.</h3>
      </div>
      <div class="howTo-media">
        <img src="/img/pressrecord.gif" height="400px" alt="record">
      </div>
    </div>

    <div class="howTo">
      <div class="howTo-text">
        <h3>Select elements for snapshot testing.</h3>
      </div>
      <div class="howTo-media">
        <img src="/img/snapshot.gif" height="400px" alt="snapshot">
      </div>
    </div>

    <div class="howTo">
      <div class="howTo-text">
        <h3>Export a full test suite with the click of a button.</h3>
      </div>
      <div class="howTo-media">
        <img src="/img/export.gif" height="400px" alt="export">
      </div>
    </div>

    
  </div>  
</div>

<style>
  h2 {
    text-align: center;
  }

  .howTo-container {
    display: grid;
    flex-direction: column;
    margin-top: 3rem;
    gap: 2rem;
  }

  .howTo {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
  }

  .howTo-media {
    border-left: 1px solid black;
    padding-left: 1.5rem;
  }

  .howTo-text {
    width: 40%;
  }

  hr {
    margin-top: 3rem;
    margin-bottom: 1.5rem;
    height: 1px;
    border-width:0;
    color: black;
    background-color: black;
  }

</style>